// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3svIe","newExpiryDate":"styles_newExpiryDate__LSbUu","footer":"styles_footer__30xn_"};